var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VCardTitle',{staticClass:"pt-0",class:{ 'cursor-pointer': _vm.hasClickEvent },on:{"click":function($event){return _vm.$emit('click')}}},[_vm._t("icon"),_c('span',{staticClass:"sr-app-container-header font-weight-bold brand-blue--text font-default"},[_vm._t("default")],2)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }